import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=4f2a6c6b&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=4f2a6c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a6c6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2a6c6b')) {
      api.createRecord('4f2a6c6b', component.options)
    } else {
      api.reload('4f2a6c6b', component.options)
    }
    module.hot.accept("./BackgroundImage.vue?vue&type=template&id=4f2a6c6b&scoped=true&", function () {
      api.rerender('4f2a6c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Task/components/BackgroundImage.vue"
export default component.exports